<template>
  <div id="reportList">
	  <plugin />
    <Tabbar msg="/report" />
	<div class="tabs">
		  <div class="tabsitem" v-if='myCountList.length>0'>
		      <div  class="tabsitemBox" :class="currentType == 0 ? 'active' : ''" data-index="0" bindtap="selectType"><span>我的报告</span></div>
		  </div>
		  <!-- <div class="tabsitem">
		      <div class="tabsitemBox" :class="currentType == 1 ? 'active' : ''" data-index="1" bindtap="selectType"><span>好友报告</span></div>
		  </div>   -->
	</div>
	<swiper  ref="mySwiper"  refs="mySwiper" >
	<!-- 自己的报告 -->
    <swiper-slide>
		<div class="noReport" v-if='myCountList.length<1&&nullList'>
		     <div class="noReportTitle">什么都没有</div>
		     <div class="noReportMsg">你还没有报告的记录~</div>
		     <div class="app-btn app-btn--shadow" @click='toQuestions'>马上测一次</div>
		 </div>
          <div class="reportListcontent self" v-if='myCountList.length>0'>
              <div class="reports">
              	  <img src="../assets/report-tip1.png" alt="再测一次" class='bannerImg' @click='toQuestions'>

                  <div class="report" @click='toReportDetail(item.id)'   data-type='1'  v-for='(item,index) in  myCountList'>
                      <div class="title">{{item.fill_name}} <span>{{item.datacreatedate}}</span></div>
                      <div class="info">
                          <div class="left">
                              <div class="tags">
                                 	<img :src="itemImg.thumb_url" alt="" v-for='itemImg in item.re_class'>
                              </div>
                              <div class="span">每袋：{{item.goods_count}}种补剂（{{item.goods_num}}颗）</div>
                          </div>
                      </div>
                  </div>

               	<div style='height:2rem;'></div>
              </div>       
          </div>
     </swiper-slide>
  </swiper>
  
	
  </div>
</template>

<script>


import Tabbar from '@/components/tabbar.vue'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import plugin from '@/components/plugin.vue'
export default {
  name: 'report',
  components: {
      Tabbar,
      swiper,
    swiperSlide,
	plugin
  },
  data() {
  	const that = this
      return {
       swiperOption:{
        slidesPerdiv: 'auto',
        centeredSlides:true,
        spaceBetween: 10,
        loop:true,
        speed:600,
        on: {
          slideChangeTransitionStart: function() {
                that.currentType = this.realIndex
	          },
	        },
	      },
       myCountList:[],
       currentType:0,
	   nullList:false,    //是否允许显示空列表
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      },
    },
    mounted() {
     
      this.getReportList()
      // this.swiper.slideTo(3, 1000, false)
    },
    methods:{

    // 获取报告列表
	    getReportList(){
	    	let that =this
	    	
	      this.axios({
	                  method: 'post',
	                  url:"index/getCountList",
	                  data:{
	                     member_id:this.$store.state.member_id 
	                  }
	                }).then(res=>{
							that.nullList =true
	                      if(!res.data.data)return

        
          
          let myCountList = [], friendCountList=[]
          res.data.data.forEach((item)=>{
            let date = new Date(item.create_date * 1000)
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            let day = date.getDate()
            if (month.length < 2) {
              month = "0" + month.toString()
            }
            if (day.length < 2) {
              day = "0" + day.toString()
            }
            item.datacreatedate = year + "-" + month + "-"+ day
            if (this.$store.state.member_id  == item.member_id){
              myCountList.push(item)
            }else{
              friendCountList.push(item)
            }
          })
          this.myCountList = myCountList
          	
	      })
	    },
	 // 做问卷
	 toQuestions(){
 		this.$router.push({name: 'beforeQuestion'});
	 },
	 // 报告详情 
	 toReportDetail(e){
	 	this.$router.push({name: 'reportDetail',params: { id:e}});
	 },  
    }
}
</script>
<style>
#reportList{
  background:rgba(244,242,240,1);
  width: 7.5rem;
  height: 100vh;
  position:relative;
  margin: 0 auto;
  
}
#reportList::-webkit-scrollbar {display:none}
.tabs{
	 display: flex;
    justify-content: center;
    padding:0.4rem 0 0.1rem;
    height: 10vh;
    box-sizing: border-box;
    border-top: 1px solid #F4F2F0;
}
 #reportList .tabsitemBox{
    color: #727171;
    font-size: 0.36rem;
    margin: 0 0.4rem;
    font-weight: bold;
    position: relative;
}
#reportList .tabsitemBox span{
    position: relative;
}
#reportList .active {
    color: #141414;
}
#reportList .active::after{
    position: absolute;
    width: 100%;
    content: "";
    left: 0;
    right: 0;
    bottom:-0.20rem;
    height: 0.1rem;
    background: #C25E4D;
    border-radius: 0.1rem;
}





#reportList .reportListcontent{
  width: 7.5rem;
  height: 90vh;
  overflow-y:auto;
  box-sizing: border-box;
}
#reportList .reportListcontent::-webkit-scrollbar {display:none}
#reportList .reports{
	width:6.9rem;
	margin: 0 auto;
}
#reportList .bannerImg{
  width:6.7rem;
  cursor:pointer;
}
#reportList .reportListcontent .report {
    width:6.7rem;
    height: 2.77rem;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0.05rem 0.15rem 0.6rem 0 rgba(220,207,191,0.4);
    border-radius: 0.1rem;
    padding: 0.4rem;
    margin: 0.4rem auto 0;
    position: relative;
	cursor:pointer;
    }
/*.content .report::after {
    position: absolute;
    content: "";
    left: 0;
    top: 0.2rem;
    width: 100%;
    height: 100%;
    border-radius: 0.1rem;
    background: rgba(220,207,191,1);
    opacity: 0.38;
    filter: blur(10px);
    z-index: -1;
}*/
#reportList .reportListcontent .report .title {

    font-size: 0.36rem;
    font-weight: 800;
    height: 0.54rem;
    line-height: 0.54rem;
    text-align:left;
}
#reportList .reportListcontent .report .title span{
    font-size: 0.24rem;
    font-weight: 500;
    height: 0.54rem;
    line-height: 0.4rem;
    color: #727171;
    float: right;
}
#reportList .reportListcontent .report .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
#reportList .reportListcontent .report .info .tags{
	text-align: left;
    height: 0.32rem;
    margin-top: 0.2rem;
    margin-bottom:0.35rem;
}
#reportList .reportListcontent .report .info .tags img {
    width: 0.32rem;
    height: 0.32rem;
    margin-right: 0.08rem;
    display: inline-block;
}
#reportList .reportListcontent .report .info .span {
    color: #999;
    margin-top: 0.1rem;
}
#reportList .reportListcontent .report .app-btn {
    width: 2rem;
	cursor:pointer;
}

#reportList .nothing {
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgba(220,207,191,0.6);
    border-radius: 10rpx;
    position: relative;
    text-align: center;
    padding: 40rpx;
    margin-top: 150rpx;
}
#reportList .nothing:after {
    position: absolute;
    z-index: -1;
    content: "";
    left: 0;
    top: 35rpx;
    width: 100%;
    height: 100%;
    background: rgba(220,207,191,1);
    border-radius: 10px;
    opacity: 0.3;
    filter: blur(10px);
}
#reportList .nothing .title {
    font-size: 42rpx;
    font-weight: bold;
    padding: 30rpx 0;
}
#reportList .nothing .msg {
    color: #505050;
}
#reportList .nothing .app-btn {
    margin: 50rpx 0;
}

#reportList .toPay{
    position: absolute;
    background-color: #C25E4D;
    color: #fff;
    border-radius: 100rpx;
    width: 180rpx;
    line-height: 60rpx;
    font-size: 24rpx;
    text-align: center;
    letter-spacing:0.5rpx;
    bottom: 60rpx;
    right:20rpx;
}

#reportList .notLoginBox{
  width: 100vw;
  position: absolute;
  left: 50%; top:50%;   
  transform: translate(-50%, -50%); 
  z-index: 999;
}
#reportList .notLoginPage{
width: 100vw;
height: 100vh;
position: fixed;
top:0;
left: 0;
background-color: #fff;
z-index:99
}
#reportList .notLoginImg{
  width: 509rpx;
  height: 277rpx;
  margin: 0rpx 120rpx 40rpx;
}
#reportList .notLoginImg image{
   width: 509rpx;
  height: 277rpx;
}
#reportList .notLoginImgTxt{
  height:40rpx;
  font-size:28rpx;
  font-family:PingFangSC;
  font-weight:300;
  color:rgba(68,68,68,1);
  line-height:40rpx;
  text-align: center;
  margin-bottom: 60rpx;
}
#reportList .notLoginImgBtn{
  display: flex;
  justify-content: center;
}

.noReport {
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgba(220,207,191,0.6);
    border-radius: 0.1rem;
    position: relative;
    text-align: center;
	width:5.5rem;
	box-sizing: border-box;
    padding: 0.4rem;
    margin: 3rem auto;
}

.noReportTitle{
    font-size: 0.42rem;
    font-weight: bold;
    padding: 0.3rem 0;
}
.noReportMsg {
	font-size: 0.24rem;
    color: #505050;
	margin-bottom:0.5rem;
}

</style>